import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";

export const ContentButtonCss = `
  display: block;
  color: var(--color-orange);
  font-family: var(--font-family);
  margin: 0 20px 0 0;
`;

export const BoldCopyCss = `
  font-family: var(--font-family-bold);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  // font-size: 0.9em;
  margin: 0;
`;

export const BoldCopy = styled.div`
  display: initial;
  ${BoldCopyCss}
`;

const Content = styled.div`
  padding: 40px 20px;
  ${props => props.bgColor && 'background-color: var(--color-'+props.bgColor+');'}
  ${props => props.fgColor && 'color: var(--color-'+props.fgColor+');'}
  ${props => props.bgColor && (document.body.dataset.bgColor = props.bgColor)}

  h1, h2, h3 {
    margin-bottom: 0.5em;
  }

  p:first-child {
    margin-block-start: 0px;
  }

  p:last-child {
    margin-block-end: 0px;
  }

  ${breakpoint("md")`
    h1, h2 {
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 1em;
    }
  `}

  ${breakpoint("xl")`
    padding: 60px 40px;
  `}

  strong {
    ${BoldCopyCss}
  }

  .button-link {
    ${ContentButtonCss}
    font-family: var(--font-family-bold);
  }
`;

export const ContentContainer = styled.div`
  max-width: 1000px;
`;

export const ContentHeader = styled.div`
  /* max-width: 220px;
  margin: 0 auto; */
`;

export const ContentDivider = styled.div`
  left: 0px;
  width: 100%;
  height: 1px;
  background-color: var(--color-orange);
`;

export const ContentImageContainer = styled.div`
  position: relative;
  height: inherit;
`;

export const ContentImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;

  background-image: url(${props => props.src});
  background-size: cover;
  background-position: 50% 50%;
  /* background-blend-mode: screen; */
`;


export default Content;
